













































































import { Component, Prop, Emit, Watch } from 'vue-property-decorator';
import UiMenu from './index.vue';
import { mixins } from 'vue-class-component';
import PlanLimitsMixin from '@/components/ui/mixins/plan-limits-mixin';

@Component
export default class UiMenuContentItem extends  mixins(PlanLimitsMixin) {
  @Prop({default: () => {}})
  item: Bemob.ListItem;

  @Prop()
  menuProps: any;

  @Prop()
  selected: string;

  @Prop()
  chevron: boolean;

  @Emit('action') 
  onAction(item: Bemob.ListItem) {}

  get isDecoractiveChevron() {
    return typeof this.chevron !== 'undefined'
  }

  get chevronOpen() {
    return this.isDecoractiveChevron 
      ? this.chevron
      : this.menu;
  }

  get planLimits():keyof BillingLimits {
    return this.item.planLimits
  }
  
  menu: boolean = false;

  handleItemClick(event: any) {
    if(this.item.subItems) {
      const menu = this.$refs.menu as UiMenu;
      menu.toggle();
    } else {
      if(!this.item.disabled) {
        if(this.showPlanLimitsIcon){
          this.handleClickPlanLimits()
        }else{
          this.item?.click?.();
        }
        
        this.onAction(this.item);
      }
    }
  }

  handleAction(item: Bemob.ListItem) {
    this.onAction(item);
  }
}
